<script setup lang="ts">
import PdsToast from '@/components/pds/PdsToast.vue';
import PdsToastButton from '@/components/pds/PdsToastButton.vue';
import { computed } from 'vue';
import { READY_UNDO_SECONDS, usePdsOrdersStore } from '../stores/orders.store';

const store = usePdsOrdersStore();
const toast = computed(() => store.readyToast);
const hasPhone = computed(() => !!toast.value?.order.contact.phone);
const heading = computed(() =>
  toast.value
    ? `#${toast.value.order.number} · ${toast.value.order.label}`
    : '',
);
</script>

<template>
  <template v-if="toast">
    <PdsToast
      v-if="toast.kind === 'undo'"
      :title="`${heading} · marquée prête`"
    >
      <template v-if="hasPhone">
        Le client sera prévenu dans {{ READY_UNDO_SECONDS }} secondes. Aucun SMS
        n’est encore parti.
      </template>
      <template v-else
        >Ce client n’a pas de numéro : aucun SMS ne part.</template
      >
      <template #aside>
        <span class="text-[14px] leading-[1.4] opacity-70">
          {{ toast.secondsLeft }} s
        </span>
        <PdsToastButton @click="store.sendReadyNow()">Fermer</PdsToastButton>
        <PdsToastButton solid @click="store.undoReady()"
          >Annuler</PdsToastButton
        >
      </template>
    </PdsToast>

    <PdsToast v-else :title="`${heading} · prête`">
      <template v-if="hasPhone">Le client a été prévenu par SMS.</template>
      <template v-else>La commande est prête.</template>
      <template #aside>
        <PdsToastButton @click="store.dismissNotice()">Fermer</PdsToastButton>
      </template>
    </PdsToast>
  </template>
</template>
